import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

const generateRandomSubtitle = () => {
  const words = [
    'The',
    'quick',
    'brown',
    'fox',
    'jumps',
    'over',
    'the',
    'lazy',
    'dog',
    'and',
    'runs',
    'into',
    'the',
    'forest',
  ];
  const subtitleLength = Math.floor(Math.random() * (13 - 8 + 1)) + 8; // Random length between 8 and 13
  let subtitle = '';
  for (let i = 0; i < subtitleLength; i++) {
    subtitle += words[Math.floor(Math.random() * words.length)] + ' ';
  }
  return subtitle.trim();
};

const HELP_PAGE_SIZE = 100;
const HELP_API_BASE_URL =
  'https://gatehousemaritime.com/wp-json/wp/v2/marinepulse';

const fetchArticles = async () => {
  const allArticles: unknown[] = [];
  let currentPage = 1;
  let totalPages = 1;

  do {
    const response = await fetch(
      `${HELP_API_BASE_URL}?acf_format=standard&per_page=${HELP_PAGE_SIZE}&page=${currentPage}`,
    );
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const pageArticles = (await response.json()) as unknown[];
    allArticles.push(...pageArticles);

    const totalPagesHeader = response.headers.get('X-WP-TotalPages');
    totalPages = totalPagesHeader ? Number(totalPagesHeader) : 1;
    currentPage += 1;
  } while (currentPage <= totalPages);

  return allArticles;
};

export const useArticles = () => {
  const onPremise = import.meta.env.VITE_ON_PREMISE === 'true';

  const fetchArticlesConditionally = async () => {
    if (!onPremise) {
      return fetchArticles();
    } else {
      const response = await fetch('offline_help.json');
      if (!response.ok) {
        throw new Error('Failed to fetch articles from local JSON');
      }
      return response.json();
    }
  };

  return useQuery(
    {
      queryKey: ['articles'],
      queryFn: fetchArticlesConditionally,
    },
    'help:articles',
  );
};
